import React from 'react';
import { Tooltip } from '@mui/material';
import Button from '../../../common/Button';
import type { ActionType } from '../../../../services/types/processStatus.types';

const ACTION_LABEL_FALLBACK: Record<ActionType, string> = {
  send_welcome: 'Send Welcome',
  trigger_stage: 'Allocate & Trigger',
};

interface ProcessActionCellProps {
  actionType?: ActionType | null;
  actionText?: string;
  actionTooltip?: string;
  enabled?: boolean;
  onActionClick: (actionType: ActionType) => void;
  isLoading?: boolean;
}

const ProcessActionCell: React.FC<ProcessActionCellProps> = ({
  actionType,
  actionText,
  actionTooltip,
  enabled = false,
  onActionClick,
  isLoading,
}) => {
  const label =
    (actionText && actionText.trim()) ||
    (actionType ? ACTION_LABEL_FALLBACK[actionType] : '') ||
    'No Action';

  const tooltip =
    (actionTooltip && actionTooltip.trim()) ||
    (enabled && actionType
      ? label
      : 'No action available for this applicant');

  const canExecute = Boolean(enabled && actionType && !isLoading);

  const button = (
    <Button
      width="130px"
      variant={canExecute ? 'contained' : 'outlined'}
      sx={{ height: '27px', fontSize: '12px', fontWeight: 500 }}
      disabled={!canExecute}
      isLoading={isLoading}
      onClick={() => {
        if (actionType && canExecute) {
          onActionClick(actionType);
        }
      }}
    >
      {label}
    </Button>
  );

  return (
    <Tooltip title={tooltip} arrow>
      <span style={{ display: 'inline-flex' }}>{button}</span>
    </Tooltip>
  );
};

export default ProcessActionCell;
